module.exports = {
  SUPPORT_TICKET_REQUEST: "SUPPORT_TICKET_REQUEST",
  SUPPORT_TICKET_LIST_SUCCESS: "SUPPORT_TICKET_LIST_SUCCESS",
  SUPPORT_TICKET_LIST_FAIL: "SUPPORT_TICKET_LIST_FAIL",
  SUPPORT_TICKET_CREATE_REQUEST: "SUPPORT_TICKET_CREATE_REQUEST",
  SUPPORT_TICKET_CREATE_SUCCESS: "SUPPORT_TICKET_CREATE_SUCCESS",
  SUPPORT_TICKET_CREATE_FAIL: "SUPPORT_TICKET_CREATE_FAIL",
};
